
import BulletItem from '@/components/blocks/bulletItem.vue';

export default {
  name: 'Bullets',

  components: {
    BulletItem,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
